import BaseService from "./BaseService";

/**
 * An agent skill available to the Flow Step Debug "Skill Instructions" stage: the KboFlow-scoped
 * AcxAgentSkills rows, which are shared across tenants rather than owned by one.
 */
export interface KboFlowStepDebugSkill {
    id: string;
    name?: string | null;
    description?: string | null;
    /** The skill's SKILL.md body — the instructions the stage edits. */
    skillText: string;
    /** Bundled files other than SKILL.md. */
    fileCount: number;
    isPublished: boolean;
    modifiedOn: string;
}

/**
 * The Flow Step Debug reads that come from the core database rather than the caller's tenant
 * database. Separate from {@link KboFlowDebugService} because the endpoints behind it are on a
 * controller with no tenant context — see KboFlowStepDebugController for why that split exists.
 * Ultra-only on the backend.
 */
export class KboFlowStepDebugService extends BaseService {
    protected urlBase = "api/KboFlowStepDebug";

    /**
     * Fetches the KboFlow-scoped agent skills the Skill Instructions stage can edit. Nothing about
     * the current organization narrows the result.
     */
    public async getSkills(
        abortSignal?: AbortSignal,
    ): Promise<KboFlowStepDebugSkill[]> {
        return this.get<KboFlowStepDebugSkill[]>(
            new URLSearchParams(),
            "Skills",
            abortSignal,
        );
    }
}
